import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchVacationsSuccess = vacations => ({
  type: actions.FETCH_VACATIONS_SUCCESS,
  vacations,
});

export const fetchVacations = (dtFrom, dtTo) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/vacations/from/${dtFrom}/to/${dtTo}`)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchVacationsSuccess(response.data));
    })
    .catch((error) => {
      const message = typeof error === 'string' ? error : 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
      dispatch(setLoading(false));
      dispatch(setMessage(message));
    });
};

export const createVacationsSuccess = vacations => ({
  type: actions.CREATE_VACATION_SUCCESS,
  vacations,
});

export const createVacations = vacations => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/vacations/lot/', vacations)
    .then((response) => {
      dispatch(setMessage('Abono criado com sucesso'));
      dispatch(setLoading(false));
      dispatch(createVacationsSuccess(response.data));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject();
    });
};

export const updateVacationsSuccess = vacations => ({
  type: actions.UPDATE_VACATION_SUCCESS,
  vacations,
});

export const updateVacations = vacations => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/vacations/lot/', vacations)
    .then((response) => {
      dispatch(setMessage('Abono atualizado com sucesso'));
      dispatch(setLoading(false));
      dispatch(updateVacationsSuccess(response));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const deleteVacationsSuccess = id => ({
  type: actions.DELETE_VACATION_SUCCESS,
  id,
});

export const deleteVacations = vacations => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/vacations/lot/delete', vacations)
    .then((response) => {
      dispatch(setMessage('Abono deletado com sucesso'));
      dispatch(setLoading(false));
      dispatch(deleteVacationsSuccess(vacations.ids));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};
